import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-4939f358"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

import { inject, nextTick, reactive } from 'vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableData',
  props: {
    modelValue: {
      type: Array,
      default: []
    },
    maxHeight: {
      type: Number,
      default: 300
    }
  },
  emits: ['show-loading'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const languageTotalList = inject('languageTotalList');
    const timeDimension = inject('timeDimension');
    const time = inject('time');
    const onlineTooltipContent = ref(t('为节目被操作的次数，例如节目被操作2次上线，数据即为2。'));
    const offlineTooltipContent = ref(t('为节目被操作的次数，例如节目被操作2次下线，数据即为2。'));
    const tableRef = ref(null);
    const spanArr = ref([]);
    const pos = ref(0);

    const objectSpanMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      // 合并列----------
      if (row.time === row.language) {
        // console.log('columnIndex', columnIndex);
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      } // 合并行----------


      if (columnIndex === 0) {
        const _row = spanArr.value[rowIndex];
        let _col = 0;

        if (_row > 0) {
          _col = 1;
        } else {
          _col = 0;
        }

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    };

    const getSpanArr = data => {
      // console.log('获取到的数据----', data);
      for (var i = 0; i < data.length; i++) {
        if (i == 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          spanArr.value.push(1);
          pos.value = 0;
        } else {
          if (data[i].time == data[i - 1].time) {
            // 如果time相等就累加，并且push 0
            spanArr.value[pos.value] += 1;
            spanArr.value.push(0);
          } else {
            // 不相等push 1
            spanArr.value.push(1);
            pos.value = i;
          }
        }
      }
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      // showPageBar: false,
      scrollbarAlwaysOn: true,
      config: {
        loading: false
      },
      maxHeight: props.maxHeight,
      'row-key': row => {
        return row.id;
      },
      viewLoading: false,
      'span-method': objectSpanMethod,
      id: 'statistics-table-warp'
    });
    const columnConfig = reactive({
      columnList: [{
        label: '时间',
        prop: 'time',
        minWidth: 200
      }, {
        label: '语言',
        prop: 'language',
        width: 100
      }, {
        label: '上线',
        prop: 'onlineCount',
        width: 130
      }, {
        label: '新增节目',
        prop: 'newAddCount',
        width: 130
      }, {
        label: '下线',
        prop: 'offlineCount',
        width: 130
      }, {
        label: '删除节目',
        prop: 'deleteCount',
        width: 150
      }, {
        label: '字幕',
        prop: 'subtitleCount',
        width: 100
      }]
    }); // 处理表格显示数据

    const formateDataToView = arr => {
      let tempArr = [];
      arr.forEach(item => {
        if (item.countList && item.countList.length) {
          item.countList.forEach(countItem => {
            let c_item = {
              time: item.time,
              ...countItem
            }; // console.log('c_item', timeDimension.value, c_item);

            tempArr.push(c_item);
          });
        }
      });
      return tempArr;
    };

    const computeLength = arr => {
      const uniqueArr = arr.reduce((acc, curr) => {
        if (!acc.find(item => item.time === curr.time)) {
          acc.push(curr);
        }

        return acc;
      }, []);
      return uniqueArr.length;
    }; // 根据时间维度格式化时间区间的每一天/每个月/每周的所有数据


    const formateTableData = data => {
      let tempArr = [];
      let defaultItemData = {
        language: '--',
        deleteCount: 0,
        newAddCount: 0,
        offlineCount: 0,
        onlineCount: 0,
        subtitleCount: 0
      }; // if (data.length) {

      if (timeDimension.value == 'day') {
        // let allTimeData = [];
        let timeArr = gainAllDateBetRange(new Date(time.value[0]), new Date(time.value[1])); // console.log('timeArr', timeArr);

        timeArr.forEach((timeItem, timeIndex) => {
          const fItem = data.find(fItem => fItem.time == timeItem);

          if (fItem) {
            tempArr.push({ ...fItem
            });
          } else {
            tempArr.push({
              time: timeItem,
              countList: [{ ...defaultItemData
              }]
            });
          }
        });
      } else if (timeDimension.value == 'month') {
        let timeArr = getMonthBetween(time.value[0], time.value[1]); // console.log('timeArr', timeArr);

        timeArr.forEach((timeItem, timeIndex) => {
          const fItem = data.find(fItem => fItem.time == timeItem);

          if (fItem) {
            tempArr.push({ ...fItem
            });
          } else {
            tempArr.push({
              time: timeItem,
              countList: [{ ...defaultItemData
              }]
            });
          }
        });
      } else {
        let timeArr = getWeekBetween(time.value[0], time.value[1]);
        timeArr.forEach((timeItem, timeIndex) => {
          timeItem.timeSection.forEach((timeSectionItem, timeSectionIndex) => {
            const fItem = data.find(fItem => fItem.time == timeSectionItem);

            if (fItem) {
              if (fItem.countList && fItem.countList.length) {
                fItem.countList.forEach(fCItem => {
                  let fCountItem = timeItem.countList.find(countItem => countItem.language == fCItem.language);

                  if (fCountItem) {
                    fCountItem.onlineCount += Number(fCItem.onlineCount);
                    fCountItem.newAddCount += Number(fCItem.newAddCount);
                    fCountItem.offlineCount += Number(fCItem.offlineCount);
                    fCountItem.deleteCount += Number(fCItem.deleteCount);
                    fCountItem.subtitleCount += Number(fCItem.subtitleCount);
                  } else {
                    timeItem.countList.push({ ...fCItem
                    });
                  }
                });
              }
            }
          });
        });
        timeArr.forEach((timeItem, timeIndex) => {
          if (!timeItem.countList.length) {
            timeItem.countList.push({ ...defaultItemData
            });
          }
        }); // console.log('timeArr', timeArr);

        tempArr = timeArr;
      } // }
      // console.log('tempArr', tempArr);


      return tempArr;
    }; // onMounted(() => {
    // })
    // 格式化时间，YYYY-MM-DD


    const dateFormat = date => {
      var year = date.getFullYear() + '-';
      var month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + month + day;
    }; // 获取一个日期范围内的所有日期，入参为Date对象


    const gainAllDateBetRange = (startDate, endDate) => {
      let dateArr = [];
      if (!(startDate instanceof Date && endDate instanceof Date)) return dateArr; // 非时间格式返回空数组

      let startTime = startDate.getTime(); // 获取开始日期的毫秒数

      let endTime = endDate.getTime(); // 获取结束日期的毫秒数

      let oneTime = 24 * 60 * 60 * 1000; // 一天的毫秒数

      for (let time = startTime; time <= endTime;) {
        dateArr.push(dateFormat(new Date(time))); // 将格式化后的时间存入结果数组

        time += oneTime; // 每次加一天
      }

      return dateArr;
    }; // 获取两个时间段内的所有年月


    const getMonthBetween = (startDate, endDate) => {
      let result = [];
      let s = startDate.split("-");
      let e = endDate.split("-");
      let min = new Date();
      let max = new Date();
      min.setFullYear(s[0], s[1]);
      max.setFullYear(e[0], e[1]);
      let curr = min;

      while (curr <= max) {
        let month = curr.getMonth(); // console.log(month);

        let str = (month == 0 ? curr.getFullYear() - 1 : curr.getFullYear()) + "-" + (month == 0 ? 12 : month < 10 ? '0' + month : month);
        let s = curr.getFullYear() + "-12";

        if (str == s) {
          str = curr.getFullYear() + "-12";
        }

        result.push(str);
        curr.setMonth(month + 1);
      }

      return result;
    };

    const getWeekBetween = (startDate, endDate) => {
      // console.log(dayjs().year());
      let timeArr = gainAllDateBetRange(new Date(startDate), new Date(endDate));
      let timeAllData = [];
      timeArr.forEach(timeItem => {
        let weekCount = dayjs(timeItem).week();
        let start = dayjs(timeItem).startOf('week').format('YYYY-MM-DD');
        let end = dayjs(timeItem).endOf('week').format('YYYY-MM-DD'); // console.log('test~~~~~~~', `${t('第')}${weekCount}${t('周')}<br>${start}~${end}`);

        timeAllData.push({
          time: Number(end.split('-')[0]) == dayjs().year() ? `${t('第')}${weekCount}${t('周')}<br>${start}~${end}` : `${end.split('-')[0]}${localStorage.getItem('language') == 'zh' ? '年' : ''} ${t('第')}${weekCount}${t('周')}<br>${start}~${end}`,
          timeSection: gainAllDateBetRange(new Date(start), new Date(end)),
          countList: []
        });
      });
      const uniqueArr = timeAllData.reduce((acc, curr) => {
        if (!acc.find(item => item.time === curr.time)) {
          acc.push(curr);
        }

        return acc;
      }, []); // console.log(`computedTime ${startDate} ~ ${endDate}`, uniqueArr);

      return uniqueArr;
    };

    const returnAllPageFunc = async () => {
      emit('show-loading', true);
      spanArr.value = [];
      pos.value = 0;
      let newArr = JSON.parse(JSON.stringify(AllData.value));
      tableConfig.data = newArr.splice((tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit, tableConfig.paginationConfig.limit);
      tableConfig.data = formateDataToView(tableConfig.data); // console.log('tableConfig.data', tableConfig.data);

      await formateCountData(languageTotalList.value);
      getSpanArr(tableConfig.data);
      setTimeout(() => {
        emit('show-loading', false);
      }, 500);
    };

    const AllData = ref([]);

    const getData = () => {
      AllData.value = formateTableData(props.modelValue);
      tableConfig.paginationConfig.total = AllData.value.length;
      returnAllPageFunc();
    };

    watch(() => props.modelValue, val => {
      nextTick(() => {
        tableConfig.paginationConfig.page = 1; // console.log('props.modelValue', val, tableConfig.data);
        // tableConfig.paginationConfig.total = val.length;

        languageTotalCountKeyArr.value = [];
        AllData.value = []; // returnAllPageFunc();

        getData();
      });
    }, {
      // immediate: true,
      deep: true
    });
    const languageTotalCountKeyArr = ref([]); // 给表格数据后面加上合计数据

    const formateCountData = async data => {
      data.forEach(item => {
        if (!languageTotalCountKeyArr.value.includes(item.language)) {
          languageTotalCountKeyArr.value.push(item.language);
        }
      }); // console.log('languageTotalCountKeyArr', languageTotalCountKeyArr.value);

      let allCountTotalData = [];
      languageTotalCountKeyArr.value.forEach(item => {
        let obj = {
          time: item + ' ' + t('合计'),
          language: item + ' ' + t('合计'),
          onlineCount: 0,
          newAddCount: 0,
          offlineCount: 0,
          deleteCount: 0,
          subtitleCount: 0,
          type: 'singleTotal'
        }; // let index = 0;

        data.forEach((d, i) => {
          if (d.language == item) {
            // index = i;
            obj.onlineCount += Number(d.onlineCount);
            obj.newAddCount += Number(d.newAddCount);
            obj.offlineCount += Number(d.offlineCount);
            obj.deleteCount += Number(d.deleteCount);
            obj.subtitleCount += Number(d.subtitleCount);
          }
        }); // console.log('obj', obj, index);

        allCountTotalData.push(obj); // data.splice(index + 1, 0, obj);
      });
      let AllLangTotalItem = {
        time: t('合计'),
        language: t('合计'),
        onlineCount: 0,
        newAddCount: 0,
        offlineCount: 0,
        deleteCount: 0,
        subtitleCount: 0,
        type: 'singleTotal'
      };
      allCountTotalData.forEach(item => {
        if (item.type == 'singleTotal') {
          AllLangTotalItem.onlineCount += Number(item.onlineCount);
          AllLangTotalItem.newAddCount += Number(item.newAddCount);
          AllLangTotalItem.offlineCount += Number(item.offlineCount);
          AllLangTotalItem.deleteCount += Number(item.deleteCount);
          AllLangTotalItem.subtitleCount += Number(item.subtitleCount);
        }
      });
      allCountTotalData.push(AllLangTotalItem); // console.log('countData', allCountTotalData);

      if (tableConfig.data && tableConfig.data.length) {
        tableConfig.data.push(...allCountTotalData);
      }
    };

    watch(() => props.maxHeight, val => {
      // console.log('props.maxHeight', val);
      if (val) {
        nextTick(() => {
          tableConfig['maxHeight'] = val;
          tableRef.value.commonTableRef.doLayout();
        });
      }
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_common_table, {
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%",
          "height": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: returnAllPageFunc,
        "column-list": columnConfig.columnList
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'onlineCount' || column.nodeDate.prop == 'offlineCount' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            content: column.nodeDate.prop == 'onlineCount' ? onlineTooltipContent.value : offlineTooltipContent.value,
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 2
          }, 1032, ["content"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "column-list"])])), [[_directive_loading, tableConfig.config.loading]]);
    };
  }

});